import React, { FC, useMemo } from "react";
import { Link } from "react-router-dom";
import { FullPageChatLinkProps } from "@zeemee/react-web-chat";
import { useRoute } from "@/routes/getRoute";
import { QualifiedChatIdSerializer } from "@/lib/QualifiedChatIdSerializer";

export const FullPageChatLink: FC<FullPageChatLinkProps> = ({
  children,
  selectedChat,
  ...props
}) => {
  const getRoute = useRoute();
  const to = useMemo(() => {
    const chat = QualifiedChatIdSerializer.serialize(selectedChat);
    return chat ? getRoute("selectedChat", { chat }) : getRoute("chat");
  }, [getRoute, selectedChat]);

  return (
    <Link {...props} to={to}>
      {children}
    </Link>
  );
};
